export default __webpack_public_path__ + "static/media/lighter-periods-ON.037045da.png";